import { useTheme } from "@mui/material";
import { PropsWithChildren, useCallback, useEffect, useState } from "react";

import { useThemeMode } from "../../hooks/useThemeMode";
import { LeftNavDrawerV2, type NavItem } from "./LeftNavDrawerV2";
import { MainV2 } from "./MainV2";
import { TopNavBarV2 } from "./TopNavBarV2";

function isEditableElement(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName.toLowerCase();
  if (tag === "input" || tag === "textarea") return true;
  if (target.isContentEditable) return true;
  return false;
}

export function LayoutV2(props: PropsWithChildren<{ navItems: NavItem[] }>) {
  const { toggleThemeMode } = useThemeMode();
  const theme = useTheme();
  const expandedWidth = theme.spacing(25);
  const collapsedWidth = theme.spacing(9);
  const [collapsed, setCollapsed] = useState(false);

  const handleDrawerToggle = useCallback(() => {
    setCollapsed((current) => !current);
  }, []);

  useEffect(() => {
    const handleGlobalKeyDown = (event: KeyboardEvent) => {
      if (isEditableElement(event.target)) return;
      const isB = event.key.toLowerCase() === "b";
      const isMod = event.metaKey || event.ctrlKey;

      if (isB && isMod) {
        event.preventDefault();
        handleDrawerToggle();
      }
    };

    window.addEventListener("keydown", handleGlobalKeyDown);
    return () => window.removeEventListener("keydown", handleGlobalKeyDown);
  }, [handleDrawerToggle]);

  return (
    <>
      <LeftNavDrawerV2
        navItems={props.navItems}
        collapsed={collapsed}
        expandedWidth={expandedWidth}
        collapsedWidth={collapsedWidth}
        onNavToggle={handleDrawerToggle}
      />
      <MainV2 collapsed={collapsed} expandedWidth={expandedWidth} collapsedWidth={collapsedWidth}>
        <TopNavBarV2 handleThemeToggle={toggleThemeMode} />
        {props.children}
      </MainV2>
    </>
  );
}
